import { GlobalStyles } from "@mui/material";
import { Z_INDEX } from "src/config/zIndex";

const globalStyles = `
body,
html {
  position: relative;
  overflow: hidden;
  width: 100vw;
  height: 100vh;
}

#root {
  height: 100%;
}

.MuiListItem-root.Mui-disabled,
.MuiButtonBase-root:disabled {
 cursor: not-allowed;
 pointer-events: auto;
}

.MuiButton-contained{
  padding: 6px 20px;

  &.Mui-disabled {
    color: rgb(255 255 255 / 45%);
  }
}

label + .MuiInput-formControl {
  margin-bottom: 10px;
}

.leaflet-div-icon {
  background-color: transparent;
  border: 0;
}

.leaflet-marker-pane {
  z-index: ${Z_INDEX.markerPane};
}

.leaflet-popup-pane {
  z-index: ${Z_INDEX.popupPane};
}
`;

export function GlobalStyle() {
  return <GlobalStyles styles={globalStyles} />;
}
